import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/doc-personalization/config';
import { DocPersonalizationFeature } from './doc-personalization-feature';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { TitleHighlightFeature } from '../titlebar/features/title-highlight-feature';

@Controller({ menuItems: MENU_CONFIGS })
export class DocPersonalizationController {
    constructor(
        private readonly feature: DocPersonalizationFeature,
        private readonly titleHighlightFeature: TitleHighlightFeature,
    ) {}

    @Menu(ActionType.PERSONALIZATION, 'shouldHide')
    public shouldHide(): boolean {
        return !this.titleHighlightFeature.shouldHighlight();
    }
}
